import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPartnerServiceOptionsResponse } from '../type/types';
import { api } from '../axiosInstance';

// 파트너가 선택한 서비스 옵션 조회
export const getPartnerServiceOptions = async () => {
  const res = await api.get<
    ApiResponseType<GetPartnerServiceOptionsResponse[]>
  >('/api/web/partners/partner-services/options');
  return res.data;
};
